import { z } from "zod";
import { createZodDto } from "nestjs-zod/dto";

export const optimizedAnalysisIterationSchema = z.object({
  type: z.literal("optimized-analysis-iteration"),
  data: z.object({
    iteration: z.number(),
    analysis: z.any(),
  }),
});

export class OptimizedAnalysisIterationDto extends createZodDto(optimizedAnalysisIterationSchema) {}
